import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the User Tenant Memberships API.
 */
export const USER_TENANT_MEMBERSHIPS_API_ENDPOINTS = {
  addUserMembership: {
    generated: 'userTenantsControllerAddUserMembershipV1',
    method: 'post',
    path: '/api/v1/admin/users/:userId/tenants',
  },
  listUserMemberships: {
    generated: 'userTenantsControllerListUserMembershipsV1',
    method: 'get',
    path: '/api/v1/admin/users/:userId/tenants',
  },
  getUserMembership: {
    generated: 'userTenantsControllerGetUserMembershipV1',
    method: 'get',
    path: '/api/v1/admin/users/:userId/tenants/:tenantId',
  },
  removeUserFromTenant: {
    generated: 'userTenantsControllerRemoveUserFromTenantV1',
    method: 'delete',
    path: '/api/v1/admin/users/:userId/tenants/:tenantId',
  },
  updateUserMembership: {
    generated: 'userTenantsControllerUpdateUserMembershipV1',
    method: 'put',
    path: '/api/v1/admin/users/:userId/memberships/:membershipId',
  },
  removeUserMembership: {
    generated: 'userTenantsControllerRemoveUserMembershipV1',
    method: 'delete',
    path: '/api/v1/admin/users/:userId/memberships/:membershipId',
  },
} as const satisfies Record<string, EndpointDef>;

export type UserTenantMembershipsEndpointName = keyof typeof USER_TENANT_MEMBERSHIPS_API_ENDPOINTS;
